/**
 * Utility functions for working with dates and time slots
 */

// Format time slot for display (e.g., "Monday-9:00 AM" -> "Monday at 9:00 AM")
export const formatTimeSlot = (timeSlot) => {
  if (!timeSlot) return '';
  
  const [day, time] = timeSlot.split('-');
  return `${day} at ${time}`;
};

// Format multiple time slots into a readable string
export const formatTimeSlots = (timeSlots) => {
  if (!timeSlots || timeSlots.length === 0) return 'No times selected';
  
  if (timeSlots.length === 1) {
    return formatTimeSlot(timeSlots[0]);
  }
  
  if (timeSlots.length === 2) {
    return `${formatTimeSlot(timeSlots[0])} and ${formatTimeSlot(timeSlots[1])}`;
  }
  
  const formatted = timeSlots.map(slot => formatTimeSlot(slot));
  const last = formatted.pop();
  
  return `${formatted.join(', ')}, and ${last}`;
};

// Get days of the week
export const getDays = () => ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// Get abbreviated days of the week
export const getDaysShort = () => ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Get time slots (8 AM to 8 PM)
export const getTimeSlots = () => [
  '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', 
  '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', 
  '6:00 PM', '7:00 PM', '8:00 PM'
];

// Convert availability object to array of time slots
export const availabilityObjToArray = (availabilityObj) => {
  if (!availabilityObj) return [];
  
  return Object.keys(availabilityObj)
    .filter(key => availabilityObj[key])
    .map(key => key);
};

// Convert availability array to object form
export const availabilityArrayToObj = (availabilityArray) => {
  if (!availabilityArray) return {};
  
  const obj = {};
  availabilityArray.forEach(slot => {
    obj[slot] = true;
  });
  
  return obj;
};

// Check if a day has any selected time slots
export const isDaySelected = (availabilityObj, day) => {
  if (!availabilityObj) return false;
  
  return Object.keys(availabilityObj)
    .some(key => key.startsWith(day) && availabilityObj[key]);
};

// Get all selected time slots for a day
export const getSelectedTimesForDay = (availabilityObj, day) => {
  if (!availabilityObj) return [];
  
  return Object.keys(availabilityObj)
    .filter(key => key.startsWith(day) && availabilityObj[key])
    .map(key => key.split('-')[1]);
};